import { onlineManager } from '@tanstack/react-query';
import { offlineService, OFFLINE_EVENTS } from '../services/offlineService';

/**
 * Sync offlineService status with TanStack Query's onlineManager.
 * This allows TanStack Query to pause queries when we're offline
 * while keeping our sophisticated offline handling intact.
 */
export function initializeOnlineManager() {
  // Set initial status
  onlineManager.setOnline(offlineService.getOnlineStatus());

  // Listen for connectivity changes from our service
  const handleConnectivityChange = (event: CustomEvent) => {
    const { isOnline } = event.detail;
    onlineManager.setOnline(isOnline);

    if (isOnline) {
      // TanStack Query will automatically refetch stale queries
      console.log('TanStack Query: Online - queries will resume');
    } else {
      console.log('TanStack Query: Offline - queries paused');
    }
  };

  offlineService.addEventListener(
    OFFLINE_EVENTS.CONNECTIVITY_CHANGED,
    handleConnectivityChange as EventListener
  );

  // Return cleanup function
  return () => {
    offlineService.removeEventListener(
      OFFLINE_EVENTS.CONNECTIVITY_CHANGED,
      handleConnectivityChange as EventListener
    );
  };
}
